import { styled, css } from 'styled-components';

export const Wrapper = styled.section`
  position: relative;
`;

export const WrapperListNotification = styled.section`
  min-width: 300px;
  max-width: 90vw;
`;

export const BtnActionNotification = styled.span`
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;

  .ant-badge {
    margin-left: 0px;
    svg {
      font-size: 20px;
      color: ${({ theme }) => theme?.colors?.textColor};
    }
  }
`;

export const WrapperTitle = styled.div`
  padding: 5px 15px;
  display: flex;
  align-items: center;
`;

export const WrapperFooter = styled.div`
  border-top: 1px solid #e1e1e1;
  padding: 10px 15px;
  text-align: center;

  button {
    font-weight: ${({ theme }) => theme.fontWeight.semiBold};
    display: inline-block;
    text-decoration: none !important;
  }
`;

export const Title = styled.h4`
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
  font-size: ${({ theme }) => theme.fontSize.md};
  width: 130px;
`;

export const SectionList = styled.div``;

export const CardWrap = styled.div<{ $isRead?: boolean }>`
  padding: 6px 15px;
  border-top: 1px solid #e1e1e1;
  position: relative;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background-color: ${({ theme }) => theme?.colors?.neutralGray4};
  }

  ${({ $isRead }) =>
    $isRead &&
    css`
      background-color: ${({ theme }) => theme?.colors?.neutralGray5};
    `}
`;

export const ContentWrap = styled.div`
  width: 70%;
`;

export const TitleNor = styled.p`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: ${({ theme }) => theme.fontSize.base};
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
`;

export const Content = styled.p`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: ${({ theme }) => theme.fontSize.base};
`;

export const MaskRead = styled.span`
  position: absolute;
  top: calc(50% - 3px);
  right: 15px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme?.colors?.danger};
  width: 6px;
  height: 6px;
`;
